import { render, staticRenderFns } from "./WashroomFrequencyV2.vue?vue&type=template&id=e51ca0f0&scoped=true"
import script from "./WashroomFrequencyV2.vue?vue&type=script&lang=js"
export * from "./WashroomFrequencyV2.vue?vue&type=script&lang=js"
import style0 from "./WashroomFrequencyV2.vue?vue&type=style&index=0&id=e51ca0f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51ca0f0",
  null
  
)

export default component.exports